// HomePage.jsx
import React, { useState } from 'react';
import logoTRH from './assets/logo-trh-menuiserie-arles.png';
import call from './assets/call.png'
import './HomePage.css'; 
import ContactSection from './sections/Contact';
import QuiSuisJe from './sections/QuiSuisJe';
import GaleriePhotos from './sections/GaleriePhotos';
import ActivitesSection from './sections/Activites';
import Footer from './sections/Footer';

const HomePage = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div className="homepage">

      <header className="header">
        <img src={logoTRH} alt="TRH Menuiserie logo" className="logo" />
        
          <a className='contactMe' href="#contact" ><img src={call} /></a>
        


       
         
    
        <nav className={`menu ${isMenuOpen ? 'open' : ''}`}>
          <a href="#activites" onClick={toggleMenu}>Activités</a>
          <a href="#realisations" onClick={toggleMenu}>Réalisations</a>
          <a href="#qui-suis-je" onClick={toggleMenu}>Qui suis-je</a>
        </nav>
      </header>

      <ActivitesSection />
      <GaleriePhotos />
      <QuiSuisJe />
      <ContactSection />

    <Footer />
      
    </div>
  );
};

export default HomePage;

/*    <button className="burger" onClick={toggleMenu}>
&#9776;
</button>*/